module.exports = __webpack_public_path__ + "0edc77a86f4772b88777c1333b070604.png";